
import ServiceConfigAdminList from './src/ServiceConfigAdmin/ServiceConfigAdminList.vue' //预警设置-管理员列表
import ServiceConfigAdminEdit from './src/ServiceConfigAdmin/ServiceConfigAdminEdit.vue' //预警设置-管理员详情 
import ServiceConfigUserList from './src/ServiceConfigUser/ServiceConfigUserList.vue' //预警设置-用户列表
import ServiceConfigUserEdit from './src/ServiceConfigUser/ServiceConfigUserEdit.vue' //预警设置-用户详情 

let views = {
  ServiceConfigAdminList,
  ServiceConfigAdminEdit,
  ServiceConfigUserList,
  ServiceConfigUserEdit
};

export default views;